import { render, staticRenderFns } from "./flows.vue?vue&type=template&id=03042ad4&scoped=true"
import script from "./flows.vue?vue&type=script&lang=js"
export * from "./flows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03042ad4",
  null
  
)

export default component.exports